<template>
  <div>
    <div v-if="Service.length != 0 || Vidange.length != 0">
      <CRow>
        <CCol col="12">
          <CRow class="cardM">
            <CCol sm="6" md="6" v-for="(ser, index) in Service" :key="ser.id">
              <CCard class="cardLDepDashbord" accent-color="warning">
                <CCardBody>
                 <CRow class="justify-content-center">
  <CCol md="6" class="text-center">
    <b-list-group class="mx-auto">
      <b-list-group-item>Matricule : {{ ser.matr }}</b-list-group-item>
      <b-list-group-item>Chauffeur : {{ ser.nom_chouffeur }}</b-list-group-item>
      <b-list-group-item>Date : {{ ser.created_at }}</b-list-group-item>
    </b-list-group>
  </CCol>
</CRow>


                  <center>
                    <div>
                      <router-link
                        :to="{
                          name: 'detaille_service',
                          params: { id: ser.matr },
                        }"
                      >
                        <CButton color="warning" class="mr-1 cl">
                          plus de détails (Service)
                        </CButton>
                      </router-link>
                    </div>
                  </center>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCol>
      </CRow>

      <!-- vidange -->
      <CRow>
        <CCol col="12">
          <CRow class="cardM">
            <CCol sm="6" md="6" v-for="(ser, index) in Vidange" :key="ser.id">
              <CCard class="cardLDepDashbord" accent-color="info">
                <CCardBody>
                  <CRow class="justify-content-center">
  <CCol md="6" class="text-center">
    <b-list-group class="mx-auto">
      <b-list-group-item>Matricule : {{ ser.matr }}</b-list-group-item>
      <b-list-group-item>Chauffeur : {{ ser.nom_chouffeur }}</b-list-group-item>
      <b-list-group-item>Date : {{ ser.created_at }}</b-list-group-item>
    </b-list-group>
  </CCol>
</CRow>

                  <center>
                    <div>
                      <router-link
                        :to="{
                          name: 'detaille_vidange',
                          params: { id: ser.matr },
                        }"
                      >
                        <CButton color="info" class="mr-1 cl">
                          plus de détails (Vidange)
                        </CButton>
                      </router-link>
                    </div>
                  </center>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </div>

    <div v-else>
      <div class="errPage-container">
        <el-row>
          <el-col :span="12">
            <p style="margin-left: 9px" class="text-jumbo">
              Oops! aucun resultat ...
            </p>

            <router-link to="/">
              <CButton
                style="
                  margin-bottom: 7px;
                  border-radius: 15px 18px;
                  margin-top: 1px;
                  margin-left: 4px;
                  padding: 10px;
                "
                color="info"
                class="mr-1 cl"
              >
                Accueil
              </CButton>
            </router-link>
          </el-col>
          <el-col style="margin-top: 12px; margin-left: 2px">
            <img
              style="height: 11cm"
              src="../assets/401_images/4m.gif"
              alt="Girl has dropped her ice cream."
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { apiDomain } from "../config";

export default {
  name: "res",
  components: {},
  data() {
    return {
      search: this.$route.query.search,
      Vidange: {},
      Service: {},
    };
  },
  created() {
    this.fetchRes(this.$route.query.search);
  },
  methods: {
    fetchRes(search) {
      axios
        .get(`${apiDomain}/api/searchMatr/${this.$route.query.search}`)
        .then(
          ({ data }) => (
            (this.Service = data.Service), (this.Vidange = data.Vidange)
          )
        );
    },
  },
};
</script>

<style>
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  border: 1px solid;
  background-color: inherit;
  border-color: #333;
  /* border-color: rgba(0, 0, 21, 0.125); */
}

.text-center {
  text-align: center;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>